import { PlayGameMeta } from "../core";

export const playGamesMock: PlayGameMeta[] = [
  {
    id: "play-attention-1",
    slug: "attention-selective-demo",
    title: "Attention sélective",
    description: "Repère des éléments ciblés au milieu des distractions.",
    category: "attention",
    difficulty: "easy",
    estimatedDurationMinutes: 5,
    recommendedAudience: "mixed",
    isDailyChallengeEligible: true,
    tags: ["focus", "cognitif"],
  },
  {
    id: "play-memory-1",
    slug: "memo-visuel-demo",
    title: "Mémoire visuelle",
    description: "Observe des cartes puis retrouve les paires (placeholder).",
    category: "memory",
    difficulty: "medium",
    estimatedDurationMinutes: 6,
    recommendedAudience: "mixed",
    isDailyChallengeEligible: true,
    tags: ["mémoire"],
  },
  {
    id: "play-logic-1",
    slug: "suite-logique-demo",
    title: "Suite logique",
    description: "Complète une suite logique simple (placeholder).",
    category: "logic",
    difficulty: "easy",
    estimatedDurationMinutes: 4,
    recommendedAudience: "mixed",
    isDailyChallengeEligible: false,
    tags: ["raisonnement"],
  },
];
